// import { RowType } from "../../../components/Editable/FormItem/Rows/RowType";
import { Big, Float, Int } from "./helper";
import { TableName } from 'bukku/redux/EditableTable/options';

export function calculateTax(item, amountB, discountAmountB, taxCodes, taxMode) {
    let taxAmountB = Big(0);
    let exemptedTaxAmountB = Big(0);
    let taxSystem = null;
    let isServiceTaxExempted = false;
    let taxCode;
    let taxRateB;
    const hybridTaxExemptedTaxRateMap = {
        SV6E2: Big(2),
    };

    if (item.tax_code_id) {
        const amountAfterDiscountB = amountB.minus(discountAmountB); // 2 dp

        // Get Tax Info
        taxCode = taxCodes.find(taxCode => taxCode.id === item.tax_code_id);
        taxRateB = Big(taxCode?.rate); // eg. 6%
        taxSystem = taxCode?.tax_system;
        isServiceTaxExempted = taxCode.is_b2b_exempted;

        if (isServiceTaxExempted) {
            switch (taxCode.code) {
                case 'SVE8C1':
                case 'SVE8C2':
                case 'SVE8C3':
                    taxRateB = Big(8);
                    break;
                case 'SVEC1':
                case 'SVEC2':
                case 'SVEC3':
                default:
                    taxRateB = Big(6);
                    break;
            }
        }

        if (taxMode === 'exclusive') {
            taxAmountB = amountAfterDiscountB.times(taxRateB)
                .div(100);
        }
        // inclusive
        else {
            taxAmountB = amountAfterDiscountB.div(taxRateB.plus(100))
                .times(taxRateB);
        }

        // const shouldRound = item.type !== RowType.bundle_item;
        // if (shouldRound)
        taxAmountB = taxAmountB.round(2);

        // Exempted Tax Amount
        if (isServiceTaxExempted) {
            exemptedTaxAmountB = taxAmountB;
            taxAmountB = Big(0); // Override taxAmountB to 0 if service tax is exempted.
        }

        if (taxCode.code in hybridTaxExemptedTaxRateMap) {
            if (taxMode === 'exclusive') {
                exemptedTaxAmountB = amountAfterDiscountB.times(hybridTaxExemptedTaxRateMap[taxCode.code])
                    .div(100);
            }
            // inclusive, just directly multiply 2% from subtotal
            else {
                exemptedTaxAmountB
                = amountAfterDiscountB.minus(taxAmountB)
                        .times(hybridTaxExemptedTaxRateMap[taxCode.code])
                        .div(100);
            }
        }
    }

    return {
        // taxAmountB,
        taxAmountB,
        taxSystem,
        isServiceTaxExempted,
        taxCodeStr: taxCode?.code || null,
        tax_amount_breakdown: {
            sales_tax_amount: taxSystem === 'mysst_sales_tax' ? Float(taxAmountB) : 0,
            // service_tax_amount: taxSystem === 'mysst_service_tax' ? Float(taxAmountB) : 0,
            service_tax: {
                rate: taxSystem === 'mysst_service_tax' ? Int(taxRateB || 0) : 0,
                amount: taxSystem === 'mysst_service_tax' ? Float(taxAmountB) : 0,
            },
            service_tax_exempted_amount: Float(exemptedTaxAmountB),
        },
    };

    // return { taxAmountB, taxSystem, isServiceTaxExempted };
}

function calculateBankItemRow(item, taxMode, taxCodes) {
    const amountB = Big(item.amount);
    const discountAmountB = Big(0);

    // Tax (float)
    const {
        taxAmountB,
        taxSystem,
        isServiceTaxExempted,
        taxCodeStr,
        tax_amount_breakdown,
    } = calculateTax(item, amountB, discountAmountB, taxCodes, taxMode);

    return {
        ...item,
        amount: Float(amountB),
        tax_amount: Float(taxAmountB),
        tax_system: taxSystem,
        is_service_tax_exempted: isServiceTaxExempted,
        tax_code: taxCodeStr,
        tax_amount_breakdown,
    };
}

// Calculate amount, and return the new record (only with line & amounts).
// No Tax / Inclusive of Tax: (Quantity * UnitPrice) - Discount
// With Tax: (Quantity * UnitPrice) - Discount + Tax
export function calculateItemRow(item, taxMode, taxCodes, activeTable = TableName.form_item) {
    if (activeTable === TableName.bank_item)
        return calculateBankItemRow(item, taxMode, taxCodes);

    // Amount (float) [Quantity * Unit Price]. Use rounded 2 dp for calculating discount and tax
    const amountUnroundedB = (
        Big(item.quantity)
            .times(Big(item.unit_price))
    );
    const amountB = amountUnroundedB.round(2);

    // Discount (float) [Calculated from amount]
    // a) if discount is %,  discount = [(qty * unitPrice), rounded 2 dp ] * discount %, rounded 2 dp
    // b) if discount is float, straight away take the discount, rounded 2 dp
    let discountAmountB = Big(0);
    if (item.discount) {
        const discountFloat = Float(item.discount);

        if (item.discount.indexOf('%') !== -1) { // Percentage
            const discountPctB = Big(discountFloat)
                .div(100);
            discountAmountB = amountB.times(discountPctB)
                .round(2);
        }
        else { // Float
            discountAmountB = Big(discountFloat)
                .round(2);
        }
    }

    // Tax (float)
    const {
        taxAmountB,
        taxSystem,
        isServiceTaxExempted,
        taxCodeStr,
        tax_amount_breakdown,
    } = calculateTax(item, amountB, discountAmountB, taxCodes, taxMode); // use rounded amount and discount for tax calculation

    return {
        ...item,
        amount: Float(amountB),
        amountUnrounded: Float(amountUnroundedB),
        discount_amount: Float(discountAmountB.round(2)),
        tax_amount: Float(taxAmountB.round(2)),
        tax_system: taxSystem,
        is_service_tax_exempted: isServiceTaxExempted,
        tax_code: taxCodeStr,
        tax_amount_breakdown,
    };
}
